import {Dialog, DialogContent, DialogTitle, Divider, Typography} from "@mui/material";
import DialogCloseButton from "../../components/Buttons/DialogCloseButton";


interface EntitiesListDialogProps {
    title: string;
    openDialog: boolean;
    setOpenDialog: (value: boolean) => void;
    entities: string[];
}

export function AffectedEntitiesListDialog({title, openDialog, setOpenDialog, entities}: EntitiesListDialogProps) {
    return (
    <Dialog open={openDialog}>
        <DialogTitle id="alert-dialog-title">{firstLetterToUpperCase(title)}
            <DialogCloseButton handleClose={() => setOpenDialog(false)}/>
        </DialogTitle>
        <DialogContent>
            {entities.length > 1000 &&
            <>
                <Typography variant="body2">
                    Når antallet er over 1000, vises denne dialogen. Dette er for å unngå at siden blir treg.
                </Typography>
                <Divider sx={{marginBottom: 2, marginTop: 2}}/>
            </>
            }
            <Typography align="justify" variant="body2">
                {entities?.length > 0 && entities?.join(", ")}
            </Typography>
        </DialogContent>
    </Dialog>)
}

function firstLetterToUpperCase(text: string) {
    return text.charAt(0).toUpperCase() + text.slice(1);
}